export default __webpack_public_path__ + "static/media/discounts_promotions.bf7b7c38.png";